import React, { useState, useEffect, useRef } from 'react';
import * as FuncionesEquipo from '../funciones/FuncionesEquipo.js';
import MensajeError from '../UI/MensajeError.js';
import ComboSelector, { TipoClave } from '../UI/campos/ComboSelector.js';
import useGetListaURL from '../../hooks/useGetListaURL.js';

const SelectSeleccionPais = (props) => {
  const pais = props.pais;
  const seleccionActual = props.seleccionActual;
  const estilo = props.estilo;
  const [lista, setLista] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  // keep fetchData in a ref so its changing identity doesn't retrigger this effect
  const fetchDataRef = useRef(fetchData);
  useEffect(() => {
    fetchDataRef.current = fetchData;
  }, [fetchData]);

  useEffect(() => {
    if (pais) {
      fetchDataRef.current('selecciones_pais/' + pais.id, setLista);
    } else {
      setLista([]);
    }
    // intentionally only depend on `pais` so updates to fetchData identity don't cause loops
  }, [pais]);

  const onItemElegido = (itemElegido) => {
    props.onSeleccionElegida(itemElegido);
  };

  const nombres = FuncionesEquipo.ConvertirListaNombresSeleccion(lista);

  let valorActual = FuncionesEquipo.EncontrarNombreSeleccion(nombres, seleccionActual);

  return (
    <React.Fragment>
      <ComboSelector
        estilo={estilo}
        lista={nombres}
        valorActual={valorActual}
        campoClave={TipoClave.ID}
        campoDescripcion="nombre"
        isCargando={isCargando}
        onItemElegido={onItemElegido}
      />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default SelectSeleccionPais;
